module.exports = __webpack_public_path__ + "img/dsci0012.b5c715b2.jpg";